<template>
  <div class="wrap">
    <div class="timeLineBox">
      <div
        class="timeLineSection"
        :class="{ oddRow: (idx + 1) % 2 === 0 }"
        :key="idx"
        v-for="(item, idx) in ContentInfos"
      >
        <div class="timeLineText">
          <h4>{{ item.Title }}</h4>
          <p>{{ item.Summary }}</p>
        </div>
        <div class="timeLineYear">
          <span>{{ item.Year }}</span>
        </div>
        <div class="timeLineImg">
          <el-image
            class="timeImg"
            :src="item.PicUrl"
            :preview-src-list="imgList"
            fit="contain"
          ></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["ContentInfos"],
};
</script>

<style lang="scss">
.timeLineBox {
  margin: 60px auto;
  position: relative;
  padding: 0 90px;
  &::before {
    position: absolute;
    border-right: 1px solid #ddd;
    height: 100%;
    left: 50%;
    top: 0;
    content: "";
    z-index: 1;
  }
}
.timeLineSection {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: 40% 20% 40%;
  margin-bottom: 40px;
  .timeLineText {
    padding: 20px;
    background: #f9f9f9;
    h4 {
      margin-bottom: 20px;
    }
  }
  .timeLineYear {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      height: 80px;
      width: 80px;
      text-align: center;
      line-height: 80px;
      color: #fff;
      background: #c6322d;
      display: inline-block;
      border-radius: 100%;
    }
  }
  .timeImg {
    width: 100%;
    height: 100%;
  }
}
.oddRow {
  .timeLineText {
    grid-column-start: 3;
    grid-column-end: 4;
  }
  .timeLineImg {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
  }
  .timeLineYear {
    grid-column-start: 2;
    grid-column-end: 3;
        grid-row-start: 1;

  }
}
</style>